import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Truncate from 'react-truncate';

import {
  Button,
  Image,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_NORMAL,
} from '../../config/constants';

import './style.scss';

export interface CardProps {
  link: string;
  label?: string;
  title: string;
  subtitle?: string;
  body?: string;
  image?: string;
  className?: string;
}

const Card: React.FC<CardProps> = (props) => {
  const {
    link,
    label,
    title,
    subtitle,
    body,
    image,
    className,
  } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const classNames = c('Card', 'u-link-box', className);

  return (
    <article className={classNames}>
      {image && (
        <div className="Card__image__wrapper">
          <Image
            // @ts-expect-error
            includeWebP
            className="Card__image"
            lazyload
            src={image}
            alt=""
          />

          {label && (
            <div className="Card__label">
              {label}
            </div>
          )}
        </div>
      )}

      <div className="Card__content">
        <h2 className="Card__title">
          {title}
        </h2>

        {subtitle && (
          <div className="Card__subtitle">
            {subtitle}
          </div>
        )}

        {body && (
          <Truncate lines={width < SCREEN_NORMAL ? 4 : 2} ellipsis="...">
            <WysiwygField
              className="Card__body"
              property="schema:text"
              html={body}
            />
          </Truncate>
        )}
      </div>

      <Button className="Card__button" href={link}>
        {t('general.more_info')}
      </Button>
    </article>
  );
};

export default Card;
